<template>
    <!-- Begin Mailchimp Signup Form -->
    <div id="mc_embed_signup">
        <form action="https://theupstairsbar.us1.list-manage.com/subscribe/post?u=3363366438eb9b347888398ee&amp;id=c847a56a5e"
              method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate"
              target="_blank" novalidate>
            <div id="mc_embed_signup_scroll">
                <label for="mce-EMAIL">Join Our Mailing List</label>
                <input type="email" value="" name="EMAIL" class="email" id="mce-EMAIL" placeholder="email address"
                       required>
                <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
                <div style="position: absolute; left: -5000px;" aria-hidden="true"><input type="text"
                                                                                          name="b_3363366438eb9b347888398ee_c847a56a5e"
                                                                                          tabindex="-1" value=""></div>
                <div class="clear"><input type="submit" value="Subscribe" name="subscribe" id="mc-embedded-subscribe"
                                          class="button"></div>
            </div>
        </form>
    </div>

    <!--End mc_embed_signup-->
</template>

<script>
    export default {
        name: "SignupForm"
    }
</script>

<style type="text/css" scoped>
    #mc_embed_signup {
        background: #fff;
        clear: left;
        font: 14px Helvetica, Arial, sans-serif;
        width: 100%;
    }

    /* Add your own Mailchimp form style overrides in your site stylesheet or in this style block.
       We recommend moving this block and the preceding CSS link to the HEAD of your HTML file. */
</style>
